// @flow
import type {Node} from 'react';
import type {ViewProps} from 'bfu-auth-client/src/login/types/Types.js';

import React from 'react';

import Box from 'react-goose/lib/position/Box';
import Button from 'react-goose/lib/Button';

import useParcelForm from 'react-dataparcels/useParcelForm';
import validation from 'react-dataparcels/validation';

import Loader from 'bfu-auth-client/src/affordance/Loader.jsx';
import BlueflagAuth from 'bfu-auth-client/src/login/data/BlueflagAuth.js';
import StatusMessage from 'bfu-auth-client/src/login/appliance/StatusMessage.jsx';
import createStatusFromParcel from 'bfu-auth-client/src/login/data/createStatusFromParcel.js';

import {usernameValidator} from 'bfu-auth-client/src/login/data/Validators.js';
import {emailValidator} from 'bfu-auth-client/src/login/data/Validators.js';
import {choosePasswordValidator} from 'bfu-auth-client/src/login/data/Validators.js';
import {choosePasswordConfirmValidator} from 'bfu-auth-client/src/login/data/Validators.js';
import {ChooseUsernameField} from 'bfu-auth-client/src/login/appliance/Fields.jsx';
import {EmailField} from 'bfu-auth-client/src/login/appliance/Fields.jsx';
import {ChoosePasswordField} from 'bfu-auth-client/src/login/appliance/Fields.jsx';
import {ChoosePasswordConfirmField} from 'bfu-auth-client/src/login/appliance/Fields.jsx';

const SignupView = (props: ViewProps): Node => {
    let {config, links, next, status} = props;
    let SigninLink = links.signin;

    let [signupParcel, signupControl] = useParcelForm({
        value: () => {
            const urlSearchParams = Object.fromEntries(new URLSearchParams(window.location.search).entries());

            return {
                username: urlSearchParams.username || '',
                email: urlSearchParams.email || '',
                choosePassword: '',
                choosePasswordConfirm: ''
            };
        },
        onChange: async (parcel) => {
            let {username, email, choosePassword} = parcel.value;
            let attributes = {email};

            return BlueflagAuth()
                .signUp(username, choosePassword, attributes)
                .then(() => next('SIGNUP_SUCCESS', {username}));
        },
        validation: () => validation({
            'username': usernameValidator,
            'email': emailValidator,
            'choosePassword': choosePasswordValidator,
            'choosePasswordConfirm': choosePasswordConfirmValidator
        })
    });

    if(signupControl.onChangeStatus.isPending) {
        return <Loader modifier="sizeMega center" text={config.signup.loadingText} />;
    }

    let submit = (e) => {
        e.preventDefault();
        signupControl.submit();
    };

    status = createStatusFromParcel(signupControl, status);

    return <div className="BlueflagAuthForm">
        {config.app.logo &&
            <img
                className="BlueflagAuthFormLogo"
                src={config.app.logo}
                title={config.app.name}
                alt={config.app.name}
            />
        }
        <StatusMessage status={status} />
        <form onSubmit={submit} method="post">
            <ChooseUsernameField
                parcel={signupParcel.get('username')}
                fieldsConfig={config.fields}
            />
            <EmailField
                parcel={signupParcel.get('email')}
                fieldsConfig={config.fields}
            />
            <ChoosePasswordField
                parcel={signupParcel.get('choosePassword')}
                fieldsConfig={config.fields}
            />
            <ChoosePasswordConfirmField
                parcel={signupParcel.get('choosePasswordConfirm')}
                fieldsConfig={config.fields}
            />
            <Box spruceName="BlueflagAuthFormButtonContainer">
                <Button spruceName="BlueflagAuthFormButton" modifier="primary" type="submit">{config.signup.submitButton}</Button>
                <SigninLink>{config.signupConfirm.backLink}</SigninLink>
            </Box>
        </form>
    </div>;
};

export default SignupView;